import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { DocRole, DwActiveLookupRequestDto } from '@digiwall/goliath-core/proxy';
import { CustomerService, SupplierService } from '@digiwall/goliath-contacts/proxy';
import { WorkOrderDayBookDto, WorkOrderDayBookService } from '@digiwall/goliath-documents/proxy';

/**
 * Option sources for the ProductionFolder planning filters, shared by the config filter panel (preset
 * selection) and the board filter (interactive controls). InterventionType comes from the enumeration
 * store (no lookup call); DayBook is the full role-scoped list; Customer and Article are wired through
 * `ng-select` + the `dwApiSelect` directive for lazy/typeahead over large lists.
 */
@Injectable({ providedIn: 'root' })
export class ProductionFolderFilterOptionsService {
  private readonly dayBookService = inject(WorkOrderDayBookService);
  private readonly customerService = inject(CustomerService);
  private readonly manufacturerService = inject(SupplierService);

  /** Day-books usable on ProductionFolder documents. */
  loadDayBooks(): Observable<WorkOrderDayBookDto[]> {
    return this.dayBookService.getAllByRole(DocRole.ProductionFolder);
  }

  /** Lazy customer lookup for `[dwApiSelect]`. */
  readonly customerSelect = (dto: DwActiveLookupRequestDto<string>) => {
    dto.onlyActive = true;
    dto.sorting = [{ property: 'name' }];
    dto.queryProperties = ['code', 'name'];
    return this.customerService.getLookupList(dto);
  };

  /** Lazy manufacturer lookup for `[dwApiSelect]`. */
  readonly manufacturerSelect = (dto: DwActiveLookupRequestDto<string>) => {
    dto.onlyActive = true;
    dto.sorting = [{ property: 'code' }];
    dto.queryProperties = ['code', 'name'];
    return this.manufacturerService.getLookupList(dto);
  };
}
